import { Container, Grid, Typography } from '@mui/material';
import { NotificationModal } from 'src/components/app-components/bonsai/notification/components/NotificationModal';
import Page from 'src/components/Page';
import Snowfall from 'src/components/special/Snowfall';
import OverviewCard from '../components/OverviewCard';
import { useOverviewPage } from '../hooks/useOverviewPage';

export const OverviewPage: React.FC = () => {
  const { overviewCardList } = useOverviewPage();

  return (
    <Page title="TOP | BONSAI">
      <NotificationModal />
      <Snowfall />
      <Container maxWidth="xl">
        <Grid container justifyContent="space-between" spacing={3}>
          <Grid item>
            <Typography color="textPrimary" variant="h3">
              TOP
            </Typography>
          </Grid>
        </Grid>
        <br />
        <Grid container justifyContent="space-between" style={{ padding: '10px' }}>
          <OverviewCard overviewCardList={overviewCardList} />
        </Grid>
      </Container>
    </Page>
  );
};
